module.exports = __webpack_public_path__ + "static/media/icon _File_Invoice_.25c54b74.svg";